
import { z } from "zod";

export const PhotoReviewAttemptTypeValues = ["ACCEPT", "REQUEST"] as const;
export const PhotoReviewAttemptTypeSchema = /* @__PURE__ */ z.enum(PhotoReviewAttemptTypeValues);
export const PhotoReviewAttemptType: (typeof PhotoReviewAttemptTypeSchema)["enum"] = { "ACCEPT": "ACCEPT", "REQUEST": "REQUEST" };
export type PhotoReviewAttemptType = (typeof PhotoReviewAttemptTypeValues)[number];
